<ng-container>
  <ng-container *ngIf="src; else initialsTmp">
    <img [alt]="alt" [src]="src" [class.rounded-circle]="rounded" />
  </ng-container>
  <ng-template #initialsTmp>
    <div
      [style]="'--nameToHslColor:' + (userName ?? account.name | hslColor)"
      [class.rounded-circle]="rounded"
      class="size--{{ size }}"
      [ngClass]="fallbackClass()"
      *ngIf="accountService.account as account"
    >
      {{ getNameInitials(userName ?? account.name) }}
    </div>
  </ng-template>

  <svg
    *ngIf="has_any_calendar"
    [matTooltip]="'invitations.calendar_connected' | translate"
    size="sm"
    cfIcon="has_calendar"
    class="tw:text-blue-30 tw:mr-1 calendar"
  ></svg>
</ng-container>
